var map = {
	"./altimetry.svg": "9e0a",
	"./biomass.svg": "8a3b",
	"./count.svg": "35ab",
	"./coverage.svg": "2df9",
	"./lines-failures.svg": "f241",
	"./variable-rate.svg": "bb21",
	"./weed.svg": "90d6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0439";